"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MintWrapperErrors = exports.MintWrapperJSON = void 0;
const anchor_contrib_1 = require("@saberhq/anchor-contrib");
exports.MintWrapperJSON = {
    version: "0.0.0",
    name: "mint_wrapper",
    instructions: [
        {
            name: "newWrapper",
            accounts: [
                {
                    name: "base",
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: "mintWrapper",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "admin",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "tokenMint",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "payer",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: "bump",
                    type: "u8",
                },
                {
                    name: "hardCap",
                    type: "u64",
                },
            ],
        },
        {
            name: "newMinter",
            accounts: [
                {
                    name: "auth",
                    accounts: [
                        {
                            name: "mintWrapper",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "admin",
                            isMut: false,
                            isSigner: true,
                        },
                    ],
                },
                {
                    name: "minterAuthority",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "minter",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "payer",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: "bump",
                    type: "u8",
                },
            ],
        },
        {
            name: "minterUpdate",
            accounts: [
                {
                    name: "auth",
                    accounts: [
                        {
                            name: "mintWrapper",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "admin",
                            isMut: false,
                            isSigner: true,
                        },
                    ],
                },
                {
                    name: "minter",
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: "allowance",
                    type: "u64",
                },
            ],
        },
        {
            name: "transferAdmin",
            accounts: [
                {
                    name: "mintWrapper",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "admin",
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: "nextAdmin",
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [],
        },
        {
            name: "acceptAdmin",
            accounts: [
                {
                    name: "mintWrapper",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "pendingAdmin",
                    isMut: false,
                    isSigner: true,
                },
            ],
            args: [],
        },
        {
            name: "performMint",
            accounts: [
                {
                    name: "mintWrapper",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "minterAuthority",
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: "tokenMint",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "destination",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "minter",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: "amount",
                    type: "u64",
                },
            ],
        },
    ],
    accounts: [
        {
            name: "MintWrapper",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "base",
                        type: "publicKey",
                    },
                    {
                        name: "bump",
                        type: "u8",
                    },
                    {
                        name: "hardCap",
                        type: "u64",
                    },
                    {
                        name: "admin",
                        type: "publicKey",
                    },
                    {
                        name: "pendingAdmin",
                        type: "publicKey",
                    },
                    {
                        name: "tokenMint",
                        type: "publicKey",
                    },
                ],
            },
        },
        {
            name: "Minter",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "mintWrapper",
                        type: "publicKey",
                    },
                    {
                        name: "minterAuthority",
                        type: "publicKey",
                    },
                    {
                        name: "bump",
                        type: "u8",
                    },
                    {
                        name: "allowance",
                        type: "u64",
                    },
                ],
            },
        },
    ],
    errors: [
        {
            code: 300,
            name: "Unauthorized",
            msg: "You are not authorized to perform this action.",
        },
        {
            code: 301,
            name: "HardcapExceeded",
            msg: "Cannot mint over hard cap.",
        },
        {
            code: 302,
            name: "MinterAllowanceExceeded",
            msg: "Minter allowance exceeded.",
        },
        {
            code: 303,
            name: "U64Overflow",
            msg: "U64 overflow.",
        },
    ],
};
exports.MintWrapperErrors = (0, anchor_contrib_1.generateErrorMap)(exports.MintWrapperJSON);
//# sourceMappingURL=mint_wrapper.js.map